import { useRef } from 'react';
import { Col, EventHandler, Label, OutlineButton, PrimaryButton, ReactSelectBox, Row } from "client/CommonComponents"
import close from "client/assets/images/Close_SuccessPopup.svg";
import { TickIcon, RejectedIcon } from 'client/CommonComponents/Icons';
import UploadIcon from 'client/assets/images/UploadIcon.svg';
import "./UploadAssets.scss"

const UploadAssets = (props: any) => {
    const uploadRef = useRef<any>(null);
    const {
        scanName,
        list = [],
        handleFileChange,
        onDownloadTemplateClick,
        removeUploadedFile,
        uploadAssetsError,
        isAssetsUploaded
    } = props

    const handleClick = () => {
        uploadRef.current.click();
    };
    return (
        <div className="upload-assets maScan">
            <Row className="mb-3">
                <Col xs={12} sm={12} md={12} lg={12}>
                    <Label required data-attribute="UploadAssets_Default_Label">M&A Scan Name</Label>
                    <ReactSelectBox
                        name="scanName"
                        value={{ label: scanName, value: scanName }}
                        isDisabled={true}
                     data-attribute="UploadAssets_scanName_SearchSelectBox" />
                </Col>
            </Row>
            <Row className="download-template-block mb-3">
                <Col xs={12} sm={12} md={4} lg={4} className="download-template-button">
                    <OutlineButton
                        text="Download Template"
                        title="Download Template"
                        onClick={onDownloadTemplateClick}
                     data-attribute="UploadAssets_Download_Template_Button" />
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} className="upload-button">
                    <PrimaryButton
                        text="Upload"
                        title="Upload"
                        onClick={handleClick}
                     data-attribute="UploadAssets_Upload_Button" />
                </Col>
            </Row>
            <Row className="upload-area">
                <Col xs={12} sm={12} md={12} lg={12}>
                    <div className="upload-attachments">
                        <div className="dragDrop">
                            <div className="dropzone">
                                <div className="draggable-container">
                                    <div className='uploadIconImg'><img src={UploadIcon} /></div>
                                    <div className="sub-headerMaScan">Drag & Drop (or) Browse</div>
                                    <input
                                        type="file"
                                        className="file-browser-input"
                                        name="uploadAssets"
                                        multiple={false}
                                        onChange={handleFileChange}
                                        accept={".xlsx, .xls"}
                                        ref={uploadRef}
                                     data-attribute="UploadAssets_uploadAssets_Input" />
                                </div>
                            </div>
                        </div>
                        {list.length ? (
                            <div className="file-list">
                                {list.map((file: any, index: number) => (
                                    <div className="file" key={file.name}>
                                        <Label title={file.name || file?.fileName} data-attribute="UploadAssets_Default_Label_2">
                                            {file.name || file?.fileName}
                                        </Label>
                                            <div className='uploadMsgIcon'>
                                                <EventHandler onEvent={removeUploadedFile} data-attribute={`UploadAssets_${((file?.name || file?.fileName || index)).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                                                    <img src={close} alt="close" />
                                                </EventHandler>
                                            </div>                                       
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="no-file">No Attachments are uploaded</div>
                        )}
                    </div>
                    {uploadAssetsError &&
                        <span className="validMessage">
                            {uploadAssetsError}
                        </span>
                    }
                </Col>
            </Row>
            {!!isAssetsUploaded?.message && <div className='maUploadSuccessfull'>
                {isAssetsUploaded?.status ?
                    <TickIcon />
                    :
                    <RejectedIcon />
                }
                &nbsp;
                <div className='alert-message'>{isAssetsUploaded?.message}</div>
            </div>}

        </div>
    )
}

export default UploadAssets